import { SectionHeading } from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

const GENRES = ["Freestyle", "Charme", "Funk Antigo", "Hip-Hop", "R&B", "Miami Bass"];
const STATS = [
  { value: "24/7", label: "No ar, todo dia" },
  { value: "06", label: "Gêneros raiz na programação" },
  { value: "RJ", label: "De Jacarepaguá para o mundo" },
];

const AboutRadio = () => (
  <section id="radio" data-testid="about-radio-section" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
    <SectionHeading
      chapter="02 // Sobre a rádio"
      title="Clássicos do Funk"
      note="Uma web rádio nascida de amizade, música e pista cheia."
    />
    <div className="grid grid-cols-12 gap-8 lg:gap-14">
      <div className="col-span-12 lg:col-span-7">
        <Reveal>
          <p className="text-sm sm:text-base text-zinc-300 leading-relaxed font-light">
            A rádio nasceu de uma amizade — amizade gerada através de algo mágico chamado música. Houve uma festa em
            Jacarepaguá em que o grande Renato DJ disse: <em className="text-zinc-100">"Temos que criar uma rádio nossa, que toque o que a gente curte."</em>{" "}
            Coincidência ou não, em coisa de semanas, a Clássicos do Funk entrava no ar.
          </p>
          <p className="mt-5 text-sm sm:text-base text-zinc-300 leading-relaxed font-light">
            De lá para cá, houveram muitas festas, conhecemos muita gente, fizemos muitas amizades. Gente do Brasil
            inteiro, do mundo todo, passou por aqui.
          </p>
          <blockquote className="mt-8 border-l-2 border-amber-400 pl-6 py-2 text-lg sm:text-xl text-zinc-100 font-light italic leading-relaxed">
            Nossa luta continua, olhando sempre para a frente, sem renegar nossas raízes — zelando pelo nosso
            movimento musical, tudo feito com carinho e dedicação.
          </blockquote>
          <div className="mt-8 flex flex-wrap gap-2">
            {GENRES.map((g) => (
              <span
                key={g}
                className="font-mono text-[10px] uppercase tracking-[0.2em] border border-[#3F4462] text-zinc-400 px-3 py-1.5 rounded-full"
              >
                {g}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
      <div className="col-span-12 lg:col-span-5 flex flex-col gap-6">
        <Reveal delay={0.1} className="border border-[#232638] bg-[#10121A] p-3">
          <img src="/images/cf.jpg" alt="Web Rádio Clássicos do Funk" className="w-full aspect-square object-cover" />
        </Reveal>
        <div className="grid grid-cols-3 gap-3">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={0.15 + i * 0.08} className="border border-[#232638] bg-[#10121A] p-4 text-center">
              <p className="font-display text-2xl sm:text-3xl font-extrabold text-amber-400">{s.value}</p>
              <p className="mt-2 font-mono text-[9px] sm:text-[10px] uppercase tracking-[0.15em] text-zinc-500 leading-relaxed">
                {s.label}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default AboutRadio;
